import React from 'react';
import { Scale } from 'lucide-react';
import { formatUnitConversion } from './catalogUnits';

const UnitConversionHint = ({ unit, unitValue, testId }) => (
  <div
    className="flex items-center gap-2 border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-900"
    data-testid={testId}
  >
    <Scale className="h-4 w-4 flex-none" />
    <span>{formatUnitConversion(unitValue, unit)}</span>
  </div>
);

export default UnitConversionHint;